const $ = jQuery.noConflict();

function isTouchDevice() {
	return 'ontouchstart' in window || navigator.msMaxTouchPoints;
}
class MainNav {
		toggleMobileHeader() {
			const ham = document.getElementById('ham');
			ham.addEventListener('click', function () {
				this.classList.toggle('open');
				document.body.classList.toggle('nav-is-toggled');
				document.body.classList.toggle('lock-scroll');
				document.querySelector('.search-field').value = '';
				document.querySelector('.search-field').classList.remove('input_big');
				document.querySelector('.site-header').classList.remove('header_input_big');
				if ( document.querySelector('.cross-btn') ) {
					document.querySelector('.cross-btn').style.display = (document.querySelector('.cross-btn').style.display == 'none') ? '' : 'none';
				}
			});

			const backLink = `<a class="nav-back-link" href="javascript:;">Back</a>`;
			ham.insertAdjacentHTML('beforeBegin', backLink);

			const body = document.querySelector('body');
			const headerOverlay = document.querySelector('.header-overlay');

			const navExpand = [].slice.call(document.querySelectorAll('.menu-item-has-children'));
			navExpand.forEach(item => {

				let subNavWrap = item.querySelector('.sub-menu');

				let subMenuTitleTmp = item.querySelector('.menu-item__before--tmp');
				let subMenuTitle = `<li class="menu-item sub-menu-title">` + subMenuTitleTmp.innerHTML + `</li>`;
				subNavWrap.insertAdjacentHTML('afterbegin', subMenuTitle);
				subMenuTitleTmp.remove();

				let subMenuFeaturedTmp = item.querySelector('.menu-item__after--tmp');
				let subMenuFeaturedDisabledClass = '';
				if (subMenuFeaturedTmp.classList.contains('mml_featured_disabled')) {
					subMenuFeaturedDisabledClass = ' sub-menu-featured_disabled';
				}
				let subMenuFeatured = `<li class="menu-item sub-menu-featured` + subMenuFeaturedDisabledClass + `">` + subMenuFeaturedTmp.innerHTML + `</li>`;
				subNavWrap.insertAdjacentHTML('beforeend', subMenuFeatured);
				subMenuFeaturedTmp.remove();

				item.querySelector('.menu-item>a').addEventListener('click', function (event) {
					event.preventDefault();
					
					let windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

					let isActive = item.classList.contains("active");
					if (document.querySelector('.menu-item-has-children.active')) {
						document.querySelector('.menu-item-has-children.active').classList.remove('active');
						headerOverlay.classList.remove('active');
						body.classList.remove('lock-scroll');
					}
					if (document.querySelector('.menu-item-cta__dropdown.active')) {
						document.querySelector('.menu-item-cta__dropdown.active').classList.remove('active');
					}
					if (!isActive) {
						item.classList.add('active');
						if (windowWidth > 991) {
							headerOverlay.classList.add('active');
						}
						body.classList.add('lock-scroll');
						document.querySelector('.header-search').classList.remove('active');
						logInExpand.classList.remove('active');
					}
					setTimeout(() => {
						if ( windowWidth <= 991 ) {
							document.querySelector('.nav-back-link').classList.add('active');
						}
					}, 300);
					document.querySelector('.header-alert').style.left = "auto";
					setTimeout(() => {
						document.querySelector('.header-alert').setAttribute("style", "left: 0");
					}, 50);
				});

				document.querySelector('.nav-back-link').addEventListener('click', function () {
					item.classList.remove('active');
					document.querySelector('.nav-back-link').classList.remove('active');
				});

				ham.addEventListener('click', function () {
					item.classList.remove('active');
					document.querySelector('.nav-back-link').classList.remove('active');
				});
			});

			headerOverlay.addEventListener('click', (event) => {
				document.querySelector('.menu-item-has-children.active').classList.remove('active');
				headerOverlay.classList.remove('active');
				document.querySelector('body').classList.remove('lock-scroll');
			});

			const logInExpand = document.querySelector('li.menu-item-cta__dropdown>a');
			logInExpand.addEventListener('click', (event) => {
				event.preventDefault();
				logInExpand.classList.toggle('active');
				document.querySelector('.menu-item-has-children.active').classList.remove('active');
				document.querySelector('.header-search').classList.remove('active');
				if (document.querySelector('.header-overlay')) {
					document.querySelector('.header-overlay').classList.remove('active');
				}
			});

			document.querySelector('main').addEventListener('click', function () {
				if (document.querySelector('.menu-item-has-children.active')) {
					document.querySelector('.menu-item-has-children.active').classList.remove('active');
				}
				if (document.querySelector('.site-header.header_input_big')) {
					document.querySelector('.site-header.header_input_big').classList.remove('header_input_big');
				}
				if (document.querySelector('.search-field.input_big')) {
					document.querySelector('.search-field.input_big').classList.remove('input_big');
					document.querySelector('.search-field').value = '';
				}
				document.getElementById('ham').classList.remove('open');
				document.querySelector('.cross-btn').style.display = '';
				document.body.classList.remove('nav-is-toggled');
				document.querySelector('.nav-back-link').classList.remove('active');
			});

			this.setSubmenuMinHeight();
			this.setFeaturedSubmenuHeightOnMobile();
			this.manageBackButtonVisibility();
			this.headerAlertSafariFix();
		}
		setSubmenuMinHeight() {
			let windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
			let subMenus = document.querySelectorAll('.sub-menu');
			let targetHeight = 0;
			for (let j = 0; j < subMenus.length; j++ ) {
				if ( windowWidth > 991 ) {
					subMenus[j].removeAttribute("style");
				}
			}
			for (let i = 0; i < subMenus.length; i++) {
				if (subMenus[i].offsetHeight > targetHeight) {
					targetHeight = subMenus[i].offsetHeight;
				}
			}
			for (let j = 0; j < subMenus.length; j++ ) {
				if ( windowWidth > 991 ) {
					subMenus[j].setAttribute("style", "min-height:" + targetHeight + "px");
				} else {
					subMenus[j].removeAttribute("style");
				}

			}
		}
		setFeaturedSubmenuHeightOnMobile() {
			let windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
			let windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
			let featuredSubmenus = document.querySelectorAll('.sub-menu-featured');
			let lowestBottom = 0;
			for (let i = 0; i < featuredSubmenus.length; i++) {
				featuredSubmenus[i].removeAttribute("style");
				let currentBottom = featuredSubmenus[i].getBoundingClientRect().bottom;
				if (currentBottom > lowestBottom) {
					lowestBottom = currentBottom;
				}
			}
			if (lowestBottom < windowHeight) {
				lowestBottom = windowHeight;
			}
			for (let i = 0; i < featuredSubmenus.length; i++) {
				if ( windowWidth <= 991 ) {
					let targetHeight = lowestBottom - featuredSubmenus[i].getBoundingClientRect().top;
					featuredSubmenus[i].setAttribute("style", "height:" + targetHeight + "px");
				} else {
					featuredSubmenus[i].removeAttribute("style");
				}
			}	
		}
		enableResizeEvents() {
			window.addEventListener('resize', () => {
				this.setSubmenuMinHeight();
				this.setFeaturedSubmenuHeightOnMobile();
				this.manageBackButtonVisibility();
				this.headerAlertSafariFix();
				this.manageOverlayVisibility();
			});
		}
		manageBackButtonVisibility() {
			let windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

			if (window.countInterval) {
				clearInterval(window.countInterval);
			}

			if (windowWidth <= 991) {
				window.countInterval = setInterval(() => {
					if (document.querySelector('.nav-back-link.active')) {
						if (document.querySelector('.nav-back-link.active').getBoundingClientRect().bottom > document.querySelector('.menu-item.active .sub-menu').getBoundingClientRect().top + 62) {
							document.querySelector('.nav-back-link.active').classList.add('hidden');
						} else {
							document.querySelector('.nav-back-link').classList.remove('hidden');
						}
						if ( ! document.querySelector('.hamburger.open') ) {
							document.querySelector('.nav-back-link').classList.add('hidden');
						}
					}
				}, 100);	
			}
		}
		headerAlertSafariFix() {
			document.querySelector('.header-alert').style.left = "auto";
			setTimeout(() => {
				document.querySelector('.header-alert').setAttribute("style", "left: 0");
			}, 100);
		}
		toggleHeaderSearch() {
			// var executeHeaderSearch = true;
			// $(document).on('click', '.header-search .search-field', function () {
			// 	if (executeHeaderSearch) {
			// 		$(this).addClass('input_big');
			// 		$('.site-header').addClass('header_input_big');
			// 	}
			// 	executeHeaderSearch = true;
			// });
			// $(document).on('click', '.header-search .cross-btn', function () {
			// 	$('.search-field').val('');
			// 	$('.search-field').toggleClass('input_big');
			// 	$('.site-header').toggleClass('header_input_big');
			// 	executeHeaderSearch = false;
			// });

			const desktopSearchTrigger = document.querySelector('.site-header-search-trigger-desktop');
			desktopSearchTrigger.addEventListener('click', () => {
				document.querySelector('.header-search').classList.toggle('active');
				if (document.querySelector('.menu-item-has-children.active')) {
					document.querySelector('.menu-item-has-children.active').classList.remove('active');
				}
				if (document.querySelector('.header-overlay')) {
					document.querySelector('.header-overlay').classList.remove('active');
				}
				document.querySelector('body').classList.remove('lock-scroll');
			});

			const mobileSearchTrigger = document.querySelector('.site-header-search-trigger-mobile');
			mobileSearchTrigger.addEventListener('click', () => {
				document.querySelector('.header-search').classList.toggle('active');
				this.headerAlertSafariFix();
			});

			const searchClose = document.querySelector('.header-search-close');
			searchClose.addEventListener('click', () => {
				document.querySelector('.header-search').classList.remove('active');
				this.headerAlertSafariFix();
			});
		}
		manageOverlayVisibility() {
			let windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
			let overlay = document.querySelector('.header-overlay');
			if ( windowWidth > 991 ) {
				if (document.querySelector('.menu-item.active')) {
					overlay.classList.add('active');
				} else {
					overlay.classList.remove('active');
				}
			} else {
				if (document.querySelector('#ham').classList.contains('open')) {
					overlay.classList.add('active');
				} else {
					overlay.classList.remove('active');
				}
			}
		}
		init() {
			this.toggleMobileHeader();
			this.toggleHeaderSearch();
			this.enableResizeEvents();
			setTimeout(() => {
				this.headerAlertSafariFix();
			}, 200);
		}
}
export default new MainNav();
